import { ref, reactive, computed, watch, onMounted } from 'vue'
import { defineStore } from 'pinia'

import API from '@util/API'

export const useLeads = defineStore('leads', () => {

    const adminStrings = typeof formychat_admin_vars !== 'undefined' ? (formychat_admin_vars.strings || {}) : {}

    const isLocked = !formychat_admin_vars.is_premium

    const allForms = formychat_admin_vars.data.forms || {}; 

    const allModes = {}
    Object.keys(allForms).forEach(mode => {
        allModes[mode] = allForms[mode].label
    })

    const state = reactive({
        modes: allModes,
        isLoading : true,
        isReloading : false,
        allSelected: false,
    })

    const total = computed(() => {
        return formychat_admin_vars?.additional[filters.value.mode]?.leads || formychat_admin_vars.total[filters.value.mode + '_leads'] || 0
    })

    const contents = ref({
        widgets: [],
        forms: {},
    })

    // Fetch contents
    const fetchContents = async () => {        

        let data = (await API.get('contents')).data

        // Widgets 
        contents.value.widgets = data.widgets.map( widget => {
            return {
                value: widget.id,
                label: widget.name,
                name: widget.name,
            }
        } )

        // Add all widget to first.
        contents.value.widgets.unshift({
            value: 'all',
            label: adminStrings.all_widgets || 'All Widgets',
            name: adminStrings.all_widgets || 'All Widgets'
        })

        // Set first widget as default if not set.
        if ( !filters.value.widget_id ) {
            filters.value.widget_id = 'all'
        }
        // Forms
        contents.value.forms = data.forms || []

        

        // Add an element with value 'null' and label 'All Forms' for each forms.

        const formKeys = Object.keys(data.forms)
        formKeys.forEach(key => {
            contents.value.forms[key].unshift({
                value: null,
                label: adminStrings.all_forms || 'All Forms',
                name: adminStrings.all_forms || 'All Forms',
            })
        })
        
        // console.log('data.forms', contents.value.forms);

        // Set first form as default if not set.
        if ( !filters.value.form_id ) {
            filters.value.form_id = contents.value.forms[0]?.value || null
        }
    }

    // Get Widget Name.
    const getWidgetName = (id) => {
        return contents.value.widgets.find( widget => widget.value == id )?.name || 'Unknown'
    }
        
    const defaultFilters = () => {
        return {
            mode : 'formychat',
            order_by: 'created_at',
            order: 'desc',
            search: '',
            page: 1,
            per_page: 20,
            after: '',
            before: '',

            widget_id : 'all',
        }
    }
    
    const filters = ref( defaultFilters() )

    // Leads.
    const leads = ref([])

     const showResetFilter = computed(() => filters.value.search || filters.value.after || filters.value.before) 

    const resetFilter = () => {
        // Replace default filters by key.
        Object.keys(defaultFilters()).forEach(key => {
            filters.value[key] = defaultFilters()[key]
        })
        
    }

    const setSort = (order_by) => {
        if ( filters.value.order_by === order_by ) {
            filters.value.order = filters.value.order === 'asc' ? 'desc' : 'asc'
        } else {
            filters.value.order_by = order_by
            filters.value.order = 'asc'
        }
    }

    // Fetch leads from API.
    const fetchLeads = async () => {
        // Make loading.
        state.isReloading = true

        let query = ''
        Object.keys(filters.value).forEach(key => {
            if ( filters.value[key] !== '' ) {
                query += `${key}=${filters.value[key]}&`
            }
        })

        // Set form_id according to mode.
        if ( filters.value.mode !== 'formychat' ) {
            query += `form_id=${filters.value[filters.value.mode + '_id']}&`
        }
        
        return new Promise( resolve => {
            API.get(`/leads?${query}`).then((response) => {
                leads.value = response.data?.map( (lead, index ) => {
                    lead.locked = isLocked && (index >= 20 || filters.value.page > 1)

                    if ( typeof lead.field === 'string' ) {
                        lead.field = JSON.parse(lead.field) || {}
                    }
                    if ( typeof lead.meta === 'string' ) {
                        lead.field = JSON.parse(lead.meta) || {}
                    }
                    
                    return lead
                } )
                // console.log('Leads', leads.value);
                resolve( leads.value )
            }).catch((error) => {
                // console.log(error);
            }).finally(() => {
                state.isLoading = false
                state.isReloading = false
            })
        })
    }

    // Watch filters.
    watch(filters.value, fetchLeads)
    // Watch filters.per_page
    watch(() => filters.value.per_page, () => {
        filters.value.page = 1
        fetchLeads()
    })

    onMounted( async ()=> {
        fetchContents()
        await fetchLeads()
        state.isLoading = false
    })
    /**
     * Delete
     */
    const deleteLeads = async (ids) => {

        // If not array, convert to array.
        if ( !Array.isArray(ids) ) {
            ids = [ids]
        }
        
        return new Promise( resolve => {
            const _leads = leads.value.filter( lead => ids.includes(lead.id) )

            // Set .deleting = true
            _leads.forEach( lead => lead.deleting = true )

            API.delete(`/leads?form=${filters.value.mode}&id[]=${ids.join('&id[]=')}`, { ids }
            ).then((response) => {
                // console.log('Deleted', response.data);

                if ( response.data.success ) {
                    _leads.forEach( lead => lead.deleted_at = true )

                    // Remove deleted leads after 300 ms.
                    setTimeout(() => {
                        state.total_formychat_leads -= ids.length

                        // Reset allSelected.
                        state.allSelected = false

                        // Fetch leads again.                
                        fetchLeads()
                    }, 300)

                    resolve(true)
                } else {
                    _leads.forEach( lead => lead.deleting = false )
                    resolve(false)
                }
            })
        })
    }

    // Selectors 

    const toggleAll = () => {
       leads.value.forEach((item, index) => {
            if ( !item.locked ) {
                leads.value[index].selected = state.allSelected;
            }
       })
    };

    const toggleSelector = (lead) => {

        // Find and toggle selected.
        leads.value.find(item => item.id === lead.id).selected = !lead.selected;

        state.allSelected = leads.value.every(item => item.selected);
    };

    const selected = computed(() => {
        return leads.value.filter(item => item.selected) || [];
    });

    // Columns.
    const columns = computed( () => {
        
        if ( filters.value.mode !== 'formychat' && leads.value && leads.value.length ) {
            
            let cols = Object.keys( leads.value[0]?.field )
            
            // return first 4 if more than 4 columns. 
            return cols.length > 4 ? cols.slice(0, 4) : cols
        }

        return ['name', 'email', 'phone', 'message', 'widget_id']
    })

    return {
        state,
        filters,
        total,
        leads,
        showResetFilter,
        resetFilter,
        setSort,
        fetchLeads,
        deleteLeads,
        toggleAll,
        toggleSelector,
        selected,
        contents,
        columns,
        getWidgetName,
    }
})